import React from "react";

import { ContainerSlider } from "./styles";

interface Props {
  value: number;
  onChange: Function;
  min: number;
  max: number;
  rotate?: string;
  height?: number;
}

function TemperatureSlider(props: Props) {
  const e = document.querySelector("#myRange") as HTMLElement;
  if (e) {
    // eslint-disable-next-line func-names
    e.oninput = function () {
      const value = ((props.value - props.min) / (props.max - props.min)) * 100;
      e.style.background = `linear-gradient(to right, #2196f3 0%, #ffd75c ${props.value}%, #F2F4F8 ${value}%, #F2F4F8 100%)`;
    };
    // linear-gradient(90deg, #2196F3 5.73%, #FFD75C 47.4%, #F43636 95.31%)
    const value = ((props.value - props.min) / (props.max - props.min)) * 100;
    e.style.background = `linear-gradient(to right, #2196f3 0%, #ffd75c ${props.value}%, #F2F4F8 ${value}%, #F2F4F8 100%)`;
  }
  return (
    <ContainerSlider>
      <input
        type="range"
        value={props.value}
        min={props.min}
        max={props.max}
        className="slider"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          props.onChange(event.target.value)
        }
        style={{ transform: `rotate(${props.rotate})`, height: props.height }}
        id="myRange"
      />
    </ContainerSlider>
  );
}
export default TemperatureSlider;
